/**
 *  获取url参数
 * @param {string} queryName 返回该字段url参数
 */
export const getLocationQuery = queryName => {
  let hash = decodeURIComponent(window.location.hash)
  const index = hash.indexOf('?')
  let queryArr = index === -1 ? [] : hash.substring(index + 1).split('&')
  let queryObj = {}
  for (let item of queryArr) {
    let arr = item.split('=')
    queryObj[arr[0]] = arr[1]
  }
  if (queryName) {
    return queryObj[queryName]
  } else {
    return queryObj
  }
}
